import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../config/config.service';
import { Modulo } from '../../../types/Modulo.type';
import { Perfil } from '../../../types/Perfil.type';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getOne(id: string){
    return this.httpClient.get<Perfil>(`${this.configService.getApiUrl()}/perfil/${id}`);
  }

  getAll(){
    return this.httpClient.get<Perfil[]>(`${this.configService.getApiUrl()}/perfil`);
  }

  getPermissoes(){
    return this.httpClient.get<Modulo[]>(`${this.configService.getApiUrl()}/permissao`);
  }

  post(perfil: Perfil){
    return this.httpClient.post<Perfil>(`${this.configService.getApiUrl()}/perfil`, perfil);
  }

  put(perfil: Perfil){
    return this.httpClient.put<Perfil>(`${this.configService.getApiUrl()}/perfil`, perfil);
  }

}
